import { campaignsUseCase } from '.'
import { elasticQuery, ELASTIC_SEARCH_CP_REQUESTS_INDEX } from '../../firebase'
import {CampaignsService} from '../services'

export const getArchives = (uid) => {
    return CampaignsService.getArchives(uid)
        .get()
        .then((doc) => {
            return doc.docs.map(archive => ({
                    ...archive.data(),
                    id: archive.id
                })
            )
        })
}

export const getPublished = (uid) => {
    return CampaignsService.getCampaignsByAuthorId(uid)
        .get()
        .then((doc) => {
            return doc.docs.map(published => ({
                ...published.data(),
                id: published.id
            }))
            .sort((a,b) => b.created_at.seconds -  a.created_at.seconds)
        })
}

export const getDrafts = (uid) => {
    return CampaignsService.getDrafts(uid)
        .get()
        .then((doc) => {
            return doc.docs.map(drafts => ({
                ...drafts.data(),
                id: drafts.id
            }))
        })
}

export const getFavorites = (uid) => {
    return CampaignsService.getFavorites(uid)
        .get()
        .then((doc) => {
            return doc.docs.map(favorites => ({
                ...favorites.data(),
                id: favorites.id
            }))
        })
}
export const restoreCampaign = async (campData) => {
    try {
        return CampaignsService.restoreCampaign(campData)
    } catch(e){
        console.error(e);
    }
}
export const archiveCampaign = async (campData) => {
    try {
        const response = await elasticQuery({
            model: ELASTIC_SEARCH_CP_REQUESTS_INDEX,
            body: {
                size: 10000,
                query: {
                    bool: {
                        must: [
                            {
                                terms: {
                                    campaigns: [campData.id]
                                }
                            },
                        ]
                    }
                }
            }
        })
        return CampaignsService.archiveCampaign(response, campData)
    } catch(e){
        console.error(e);
    }
}

export const removeFromFavorite = (campData, uid) => {
    try {
        CampaignsService.removeFromFavorites(campData, uid)
    } catch(e) {
        console.error(e);
    }
}